var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertDangerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.795 .59)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EF5212",
    fillRule: "nonzero",
    cx: 9.205,
    cy: 9.409,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 9.227,
    cy: 13.432,
    r: 1.023
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2.045,
    strokeLinecap: "round",
    d: "M9.205 5.409v4.255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDangerIcon);
export default __webpack_public_path__ + "static/media/alert-danger-icon.10bb6b94b85bf8e76e28da902464d676.svg";
export { ForwardRef as ReactComponent };